import { render, staticRenderFns } from "./Renda.vue?vue&type=template&id=60d3854c&"
import script from "./Renda.vue?vue&type=script&lang=js&"
export * from "./Renda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports